import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {makeStyles} from 'tss-react/mui';
import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import MUIDataTable from 'mui-datatables';
//DS
import {loadingModal, openMsg} from 'src/redux-app';
import {SelectPlus, hooks, SelectDs} from 'lib.front';
import {transformacion} from 'lib.common';
import {urlsCrm} from '../../../config/keys';
import {queryCliente} from './queries';
import {column, configInfoAdicional, options, components} from './config';

const {denominacionCliente} = transformacion;
const {useApolloLazyQ} = hooks;

const useStyles = makeStyles()(theme => ({
   container: {
      marginTop: theme.spacing(2),
      maxWidth: 'none',
      width: '95%'
   },
   input: {
      maxWidth: 500,
   }
}));

function HistorialLicencia(props) {
   const dispatch = useDispatch();
   const {classes, cx} = useStyles();
   //Modal de espera
   function openWaitModal(load) {
      dispatch(loadingModal(load));
   }
   //Modal para mensajes
   function openMsgModal(msg) {
      dispatch(openMsg(msg));
   }
   //Estados
   const [cliente, setCliente] = useState(null);
   useEffect(() => {
      buscarLicencias();
      setLicenciasMostradas([]);
      limpiarLicencia();
   }, [cliente]);

   useEffect(() => {
      const firstTable = document.querySelector('.MuiTable-root');
      if (firstTable) {
         firstTable.classList.add('firstMuiTable');
      }
   }, []);

   //Data de cliente
   function buscarLicencias() {
      if (cliente && cliente.value !== '') {
         getCliente({variables: {ruc: cliente.value}});
      }
   }
   const [getCliente, {data}] = useApolloLazyQ(queryCliente, {
      callbackError: openMsgModal,
      callbackLoading: openWaitModal
   });

   const [licenciaElegida, setLicenciaElegida] = useState('');
   const [licenciasMostradas, setLicenciasMostradas] = useState([]);
   function handleOnChange(e) {
      setLicenciaElegida(e.target.value);
   }
   useEffect(() => {
      if (licenciaElegida && licenciaElegida !== -1 && data && data.historialLicencia) {
         setLicenciasMostradas(
            data.historialLicencia.filter(item => item.codigo === licenciaElegida.value)
         );
      }
   }, [licenciaElegida]);

   function limpiarLicencia() {
      setLicenciaElegida(null);
   }

   return (
      <Container className={cx('containerbox', classes.container)}>
         <Grid container spacing={1}>
            <Grid item xs={12}>
               <Typography variant="h4" gutterBottom align="center">
                  Historial de licencia de cliente
               </Typography>
            </Grid>
            <Grid container item xs={12}>
               <Grid container item xs={12} spacing={1} alignItems="center">
                  <Grid item xs={12} md={6} sm={6}>
                     <SelectPlus
                        url={urlsCrm.graph}
                        name="cliente"
                        label="RUC"
                        entidad="clientes"
                        campos={[
                           'codigo',
                           'nombre',
                           'apPaterno',
                           'apMaterno',
                           'razonSocial',
                           'nroDoc'
                        ]}
                        value={cliente}
                        onChange={elegido => {
                           setCliente(elegido);
                        }}
                        genId={registro => {
                           return registro.nroDoc;
                        }}
                        genLabel={denominacionCliente}
                        InputLabelProps={{shrink: true}}
                        variant="outlined"
                        margin="dense"
                        fullWidth
                        isClearable
                        excesoElementos
                        recuperarOnFocus
                        placeholder="Elija un cliente:"
                     />
                  </Grid>
                  <Grid item xs={12} md={6} sm={6}>
                     <SelectPlus
                        id="selectLicencia"
                        name="licencia"
                        label="Código de activación"
                        variant="outlined"
                        value={licenciaElegida}
                        onChange={elegido => {
                           setLicenciaElegida(elegido);
                        }}
                        margin="dense"
                        campos={['codigo']}
                        data={
                           data && data.historialLicencia
                              ? [
                                   ...Array.from(
                                      new Set(data.historialLicencia.map(item => item.codigo))
                                   ).map(codigo => ({codigo}))
                                ]
                              : []
                        }
                        genId={registro => {
                           return registro.codigo;
                        }}
                        InputLabelProps={{shrink: false}}
                        fullWidth
                        disabled={cliente === null}
                        className={classes.input}
                        placeholder="Elija una llave:"
                     />
                  </Grid>
               </Grid>
               <Grid className={classes.container} item xs={12}>
                  {licenciasMostradas !== undefined && licenciasMostradas !== null && (
                     <MUIDataTable
                        data={licenciasMostradas}
                        columns={[...column, ...configInfoAdicional]}
                        options={options}
                        components={components}
                     />
                  )}
               </Grid>
            </Grid>
         </Grid>
      </Container>
   );
}

export default HistorialLicencia;
